
export function getSidebarConfig(hasPermission, icons) {
  return [
    {
      section: "",
      items: [
        {
          id: "evals",
          title: "Evals",
          svg: icons.eval_builder,
          subItems: [
            // CREATE section
            ...(hasPermission("datasets") ? [
              {
                id: "evals-divider-create",
                isDivider: true,
                label: "CREATE",
              },
              {
                id: "eval-builder",
                label: "Eval Builder",
                svg: icons.eval,
                redirect: "/creator-profile?page=eval-builder",
              },
              {
                id: "eval-import",
                label: "Import Eval",
                svg: icons.upload_datasets,
                redirect: "/creator-profile?page=eval-import",
              },
            ] : []),
            // MANAGE section
            ...(hasPermission("datasets") ? [
              {
                id: "evals-divider-manage",
                isDivider: true,
                label: "MANAGE",
              },
              {
                id: "eval-datasets",
                label: "Edit Evals",
                redirect: "/creator-profile?page=eval-datasets",
                svg: icons.edit_evals,
              },
              {
                id: "eval-listings",
                label: "Edit Listings",
                redirect: "/creator-profile?page=evals",
                svg: icons.edit_eval_listings,
              },
            ] : []),
            // RESULTS section
            ...(hasPermission("buy") ? [
              {
                id: "evals-divider-results",
                isDivider: true,
                label: "RESULTS",
              },
              {
                id: "eval-results",
                label: "Eval Runs",
                redirect: "/creator-profile?page=eval-results",
                svg: icons.rfp_proposals,
              },
              {
                id: "eval-annotate",
                label: "See Results",
                redirect: "/creator-profile?page=eval-annotate",
                svg: icons.dataset_edit,
              },
            ] : []),
          ],
        },
        {
          id: "datasets",
          title: "Datasets",
          svg: icons.datasets,
          subItems: [
            // CREATE section
            ...(hasPermission("datasets") ? [
              {
                id: "datasets-divider-create",
                isDivider: true,
                label: "CREATE",
              },
              {
                id: "new-dataset",
                label: "Upload Datasets",
                svg: icons.upload_datasets,
                redirect: "/dataset-create",
              },
              // MANAGE section
              {
                id: "datasets-divider-manage",
                isDivider: true,
                label: "MANAGE",
              },
              {
                id: "edit-datasets",
                label: "Edit Datasets",
                redirect: "/creator-profile?page=datasets",
                svg: icons.edit_evals,
              },
              {
                id: "edit-listings",
                label: "Edit Listings",
                redirect: "/creator-profile?page=listings",
                svg: icons.edit_eval_listings,
              },
            ] : []),
            // AUCTIONS section
            ...((hasPermission("buy") || hasPermission("listings")) ? [
              {
                id: "datasets-divider-auctions",
                isDivider: true,
                label: "AUCTIONS",
              },
              ...(hasPermission("buy")
                ? [
                    {
                      id: "bids",
                      label: "Bids",
                      redirect: "/creator-profile?page=bids",
                      svg: icons.bids
                    },
                  ]
                : []),
              ...(hasPermission("listings")
                ? [
                    {
                      id: "offers",
                      label: "Offers",
                      redirect: "/creator-profile?page=offers",
                      svg: icons.offers,
                    },
                  ]
                : []),
            ] : []),
          ],
        },

        ...(hasPermission("listings")
          ? [
            {
              id: "sales",
              title: "Sales",
              redirect: "/creator-profile?page=sales",
              svg: icons.sales,
            },
          ]
          : []),
        {
          id: "rfp",
          title: "RFPs",
          svg: icons.rfps,
          subItems: [

            {
              id: "edit-rfps",
              label: "Edit RFPs",
              redirect: "/creator-profile?page=rfp",
              svg: icons.rfp_edit
            },

            ...((hasPermission("buy") && hasPermission("rfp-create")) || hasPermission("datasets") ? [
              {
                id: "rfp-proposals-list",
                label: "Proposals",
                redirect: "/creator-profile?page=rfp-proposals-list",
                svg: icons.rfp_proposals,
              },
            ] : []),

            ...(hasPermission("buy") && hasPermission("rfp-create") ? [
              {
                id: "rfp-requests",
                label: "Requests",
                redirect: "/creator-profile?page=rfp-requests",
                svg: icons.rfp_requests,
              },
            ] : []),
            ...(hasPermission("datasets") ? [
              {
                id: "rfp-responses",
                label: "Responses",
                redirect: "/creator-profile?page=rfp-responses",
                svg: icons.rfp_responses,
              },
            ] : []),
          ],
        },


        {
          id: "api-credits",
          title: "Benchmark credits",
          redirect: "/creator-profile?page=api-credits",
          svg: icons.sales,
        },

        ...(hasPermission("buy")
          ? [
            {
              id: "purchases",
              title: "Purchases & Downloads",
              redirect: "/creator-profile?page=purchases",
              svg: icons.purchases
            },
          ]
          : []),
      ],
    },
  ];
}
